import { TImage } from '@components/typescript';
// import { useResponsive } from '@features/responsive';
// import getCurrentDevice from '@utils/getCurrentDevice';

const GetImageAlt = (images: TImage) => {
  // const { currentBreakpoint } = useResponsive();
  // const currentDevice = getCurrentDevice(currentBreakpoint);
  if (!images.desktop && !images.tablet && !images.mobile) return '';
  if (images.desktop && typeof images.desktop !== 'string') return images.desktop.metadata.alt;

  // switch (currentDevice) {
  //   case 'mobile':
  //     if (typeof images.mobile !== 'string') return images.mobile?.metadata.alt || '';
  //     break;
  //   case 'tablet':
  //     if (typeof images.tablet !== 'string') return images.tablet?.metadata.alt || '';
  //     break;
  //   default:
  //     if (typeof images.desktop !== 'string') return images.desktop?.metadata.alt || '';
  // }

  return '';
};

export default GetImageAlt;
